module.exports = __webpack_public_path__ + "kz.75bd15e18dc2377bb732.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/kz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/kz.svg
// module chunks = styles